import React from "react";
// import Image from "../common/CloudinaryImage.js";
import Image from "../../components/newVersion/CloudinaryImage";
import Text from "../common/Text";
import Title from "../common/Title";

const Screenshots = ({ className, item }) => {
    // Montamos array con imágenes
    const screenshots = [];
    for (let i = 1; i <= item.screenshots; i++) {
        screenshots.push(i);
    }

    return (
        <>
            <div className={`${className}`}>
                <div className="container py-20 lg:px-0">
                    <Title className="text-left">Capturas</Title>
                    <Text>
                        Aquí puedes ver algunas imágenes de la aplicación en
                        funcionamiento.
                    </Text>
                    <div className="mt-10 grid grid-cols-1 gap-10 sm:grid-cols-2 md:grid-cols-3">
                        {screenshots.map((i) => {
                            return (
                                <div
                                    key={i}
                                    className="h-[600px] overflow-hidden rounded-lg shadow"
                                >
                                    <Image
                                        alt={`${item.name} screenshot ${i}`}
                                        filename={`apps/${item.name}/screenshot${i}`}
                                        className="h-full w-full object-contain"
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Screenshots;
